module.exports = __webpack_public_path__ + "static/media/apply-2.fe035308.svg";